import React from "react";
import { useTheme } from "./theme";

// Shared LaunchSafely modal surface referenced by Results.tsx and other newtool flows
interface ModalProps {
  title: string;
  children: React.ReactNode;
  onClose: () => void;
}

export default function Modal({ title, children, onClose }: ModalProps) {
  const { theme } = useTheme();
  const palette = theme.palette;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: palette.overlay,
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        minHeight: "100vh",
        padding: "3rem 1.5rem 1.5rem",
        boxSizing: "border-box",
        overflowY: "auto",
        zIndex: 1000,
      }}
      role="dialog"
      aria-modal="true"
      aria-label={title}
    >
      <div
        style={{
          background: palette.card,
          border: `1px solid ${palette.border}`,
          borderRadius: "16px",
          maxWidth: "640px",
          width: "100%",
          padding: "2rem",
          boxShadow: palette.shadow,
          position: "relative",
          color: palette.textPrimary,
          maxHeight: "min(90vh, 720px)",
          overflowY: "auto",
        }}
      >
        <button
          onClick={onClose}
          aria-label="Close"
          style={{
            position: "absolute",
            top: "0.75rem",
            right: "1rem",
            fontSize: "1.1rem",
            background: "none",
            border: "none",
            color: palette.textMuted,
            cursor: "pointer",
          }}
        >
          X
        </button>

        <h3
          style={{
            fontSize: "1.25rem",
            fontWeight: 700,
            marginBottom: "1rem",
            color: palette.textPrimary,
          }}
        >
          {title}
        </h3>

        <div>{children}</div>
      </div>
    </div>
  );
}
